import { useState } from "react";

/** Bild mit Lazy-Loading und Unsplash-Fallback, falls die generierte Datei (noch) fehlt */
export default function ZWImage({ src, fallback, alt, className, caption, subcaption, testid }) {
  const [err, setErr] = useState(false);
  return (
    <div className={`relative overflow-hidden ${className || ""}`} data-testid={testid}>
      <img
        src={err && fallback ? fallback : src}
        onError={() => setErr(true)}
        alt={alt}
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover"
      />
      {(caption || subcaption) && (
        <>
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-5 z-10 space-y-1 text-white">
            {subcaption && (
              <div className="text-xs font-bold tracking-wider uppercase text-[#A3D9A5]">{subcaption}</div>
            )}
            {caption && <div className="text-base font-bold">{caption}</div>}
          </div>
        </>
      )}
    </div>
  );
}
